module.exports = __webpack_public_path__ + "img/jurisdiction.083d5ca8.png";